import React, { useState, useEffect } from "react";
import apiClient from '../../services/apiClient';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Email.css";

const CreateEmailTemplate = ({ isEdit, emailTemplateId }) => {
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [editorInstance, setEditorInstance] = useState(null);
  const [selectedValue1, setSelectedValue1] = useState("");
  const navigate = useNavigate();

  // Update dropdown state
  const handleSelectChange = (e) => {
    setSelectedValue1(e.target.value);
  };

  // Insert selected Smart Text into editor
  const handleInsertInputField = () => {
    const value = selectedValue1;
    if (!value) {
      Swal.fire({
        icon: "warning",
        title: "Select a field",
        text: "Please choose a smart text field first!",
      });
      return;
    }

    const placeholder = value.startsWith("{") ? value : `{${value}}`;

    if (editorInstance) {
      try {
        editorInstance.core.focus();
        editorInstance.insertHTML(placeholder);
      } catch (err) {
        console.error("Insert failed:", err);
      }
    }
  };

  // Add custom button in SunEditor toolbar → opens sidebar
  const handleToolbarButtonClick = () => {
    const popupTrigger = document.getElementById("smarttextpopup");
    if (popupTrigger) {
      popupTrigger.click(); // open sidebar
    }
  };

  useEffect(() => {
    const addCustomButton = () => {
      const sunEditorToolbar = document.querySelector(".se-menu-list");
      if (sunEditorToolbar && editorInstance && editorInstance.core) {
        if (!sunEditorToolbar.querySelector(".customAction")) {
          const customButton = document.createElement("button");
          customButton.classList.add(
            "sun-editor-action",
            "customAction",
            "p-2"
          );
          customButton.innerHTML = '<i class="fa fa-magic"></i>';
          customButton.title = "Add Smart Text";

          customButton.addEventListener("click", handleToolbarButtonClick);

          sunEditorToolbar.appendChild(customButton);
        }
      }
    };

    if (editorInstance && editorInstance.core) {
      setTimeout(() => {
        addCustomButton();
      }, 200);
    }
  }, [editorInstance]);

  // Load template if editing
  useEffect(() => {
    if (isEdit && emailTemplateId) {
      apiClient
        .get(
          `/email-templates/${emailTemplateId}`
        )
        .then((response) => {
          setSubject(response.data.title);
          setContent(response.data.content);
        })
        .catch((error) => {
          console.error("Error fetching template:", error);
          Swal.fire("Error", "Failed to fetch email template.", "error");
        });
    }
  }, [isEdit, emailTemplateId]);

  const editorOptionsShow = {
    height: 200,
    plugins: allPlugins,
    fontSize: ["12", "14", "16", "18", "20"],
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
      ],
    ],
    imageRotation: false,
  };

  const handleSubmit = () => {
    const emailTemplate = {
      title: subject,
      content: editorInstance ? editorInstance.getContents() : content,
      userid: JSON.parse(localStorage.getItem("user")).user.id,
    };

    const req = isEdit
      ? apiClient.put(
          `/email-templates/${emailTemplateId}`,
          emailTemplate
        )
      : apiClient.post(
          `/email-templates`,
          emailTemplate
        );

    req
      .then(() => {
        Swal.fire(
          isEdit ? "Updated!" : "Created!",
          `Your email template has been ${isEdit ? "updated" : "created"}.`,
          "success"
        );
        navigate("/email");
      })
      .catch((error) => {
        console.error("Save failed:", error);
        Swal.fire("Error", "Failed to save email template.", "error");
      });
  };

  return (
    <div className="email-template-container">
      {/* Subject */}
      <div className="d-flex align-items-center bg-white pt-2 ps-4 border shadow-sm">
        <h6 className="pe-3">Subject</h6>
        <input
          className="w-100 py-3 border-0 outline-none"
          type="text"
          placeholder="What's the topic?"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
      </div>

      {/* SunEditor */}
      <SunEditor
        setOptions={editorOptionsShow}
        getSunEditorInstance={setEditorInstance}
        placeholder="You can edit your message..."
        setContents={content}
        onChange={setContent}
      />

      {/* Save Button */}
      <div className="d-flex justify-content-center pt-4">
        <button
          type="button"
          className="email-template-done-btn"
          onClick={handleSubmit}
        >
          {isEdit ? "UPDATE" : "DONE"}
        </button>
      </div>

      {/* Hidden trigger to open sidebar */}
      <div
        id="smarttextpopup"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight2"
        aria-controls="offcanvasRight2"
        className="d-none"
      ></div>

      {/* Sidebar Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight2"
        aria-labelledby="offcanvasRightLabel"
        data-bs-backdrop="false"
      >
        <div className="w-100 text-start header">
          <button
            type="button"
            className="btn-close mt-3 ms-4 text-black"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>

          <div className="text-center py-3">
            <h5>Smart Text</h5>
          </div>
        </div>
        <div className="create-contract">
          <div className="offcanvas-body p-0">
            <div className="single_box mt-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h6>Field content types {selectedValue1}</h6>
                  <select
                    value={selectedValue1}
                    onChange={handleSelectChange}
                    style={{
                      width: "300px",
                      height: "40px",
                      outline: "none",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e8e4e4",
                    }}
                  >
                    <option value="">Select your option</option>
                    <option value="Event_Name">Event Name</option>
                    <option value="First_Client_First_Name">
                      First Client First Name
                    </option>
                    <option value="First_Client_Last_Name">
                      First Client Last Name
                    </option>
                    <option value="First_Client_Email">
                      First Client Email
                    </option>
                    <option value="Event_Type">Event Type</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="single_box mt-4">
              <div className="d-flex align-items-center justify-content-between">
                <button
                  onClick={handleInsertInputField}
                  style={{
                    width: "100px",
                    height: "40px",
                    borderRadius: "20px",
                    outline: "none",
                    backgroundColor: "#4f46e5",
                    border: "1px solid #e8e4e4",
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  Insert
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEmailTemplate;
